/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Notifications_Builds1Inputs */

const id_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const ms_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan`)
};

const da_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const de_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const en_us2_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const es_es2_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones`)
};

const es_mx2_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones`)
};

const fil_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Build`)
};

const fr_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilations`)
};

const it_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const hu_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-ek`)
};

const nl_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const no_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const pl_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacje`)
};

const pt_br2_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds`)
};

const pt_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilações`)
};

const ro_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilări`)
};

const fi_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversiot`)
};

const sv_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggen`)
};

const vi_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng`)
};

const tr_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapılar`)
};

const cs_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestavení`)
};

const bg_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компилации`)
};

const ru_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сборки`)
};

const uk_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Збірки`)
};

const ar_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البنيات`)
};

const hi_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड`)
};

const th_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์`)
};

const ja_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド`)
};

const zh_cn2_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建版本`)
};

const zh_hant1_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置版本`)
};

const ko_offerdetail_notifications_builds1 = /** @type {(inputs: Offerdetail_Notifications_Builds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드`)
};

/**
* | output |
* | --- |
* | "Builds" |
*
* @param {Offerdetail_Notifications_Builds1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_notifications_builds1 = /** @type {((inputs?: Offerdetail_Notifications_Builds1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Notifications_Builds1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_notifications_builds1(inputs)
	if (locale === "ms") return ms_offerdetail_notifications_builds1(inputs)
	if (locale === "da") return da_offerdetail_notifications_builds1(inputs)
	if (locale === "de") return de_offerdetail_notifications_builds1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_notifications_builds1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_notifications_builds1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_notifications_builds1(inputs)
	if (locale === "fil") return fil_offerdetail_notifications_builds1(inputs)
	if (locale === "fr") return fr_offerdetail_notifications_builds1(inputs)
	if (locale === "it") return it_offerdetail_notifications_builds1(inputs)
	if (locale === "hu") return hu_offerdetail_notifications_builds1(inputs)
	if (locale === "nl") return nl_offerdetail_notifications_builds1(inputs)
	if (locale === "no") return no_offerdetail_notifications_builds1(inputs)
	if (locale === "pl") return pl_offerdetail_notifications_builds1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_notifications_builds1(inputs)
	if (locale === "pt") return pt_offerdetail_notifications_builds1(inputs)
	if (locale === "ro") return ro_offerdetail_notifications_builds1(inputs)
	if (locale === "fi") return fi_offerdetail_notifications_builds1(inputs)
	if (locale === "sv") return sv_offerdetail_notifications_builds1(inputs)
	if (locale === "vi") return vi_offerdetail_notifications_builds1(inputs)
	if (locale === "tr") return tr_offerdetail_notifications_builds1(inputs)
	if (locale === "cs") return cs_offerdetail_notifications_builds1(inputs)
	if (locale === "bg") return bg_offerdetail_notifications_builds1(inputs)
	if (locale === "ru") return ru_offerdetail_notifications_builds1(inputs)
	if (locale === "uk") return uk_offerdetail_notifications_builds1(inputs)
	if (locale === "ar") return ar_offerdetail_notifications_builds1(inputs)
	if (locale === "hi") return hi_offerdetail_notifications_builds1(inputs)
	if (locale === "th") return th_offerdetail_notifications_builds1(inputs)
	if (locale === "ja") return ja_offerdetail_notifications_builds1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_notifications_builds1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_notifications_builds1(inputs)
	return ko_offerdetail_notifications_builds1(inputs)
});
export { offerdetail_notifications_builds1 as "offerDetail.notifications.builds" }